import { Collapse, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar } from "@mui/material"
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Link } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";

import systemConfig from './../assets/images/svg/menu/system-config.svg';
import deviceConfig from './../assets/images/svg/menu/device-config.svg';
import devicePendingRequest from './../assets/images/svg/menu/device-pending-request.svg';
import deviceHistory from './../assets/images/svg/menu/device-history.svg';
import deviceLogs from './../assets/images/svg/menu/device-logs.svg';

import protocolImg from './../assets/images/svg/menu/protocol.svg';
import communicationChannel from './../assets/images/svg/menu/communication-channel.svg';
import deviceImage from './../assets/images/svg/menu/device-image.svg';
import deviceGraph from './../assets/images/svg/menu/device-graph.svg';
import deviceType from './../assets/images/svg/menu/device-type.svg';
import frequency from './../assets/images/svg/menu/frequency.svg';
import hmiDeviceCard from './../assets/images/svg/menu/hmi-device-card.svg';
import location from './../assets/images/svg/menu/location.svg';
import statusCode from './../assets/images/svg/menu/status-code.svg';
import timeGroup from './../assets/images/svg/menu/time-group.svg';
import uart from './../assets/images/svg/menu/uart.svg';
import uartBaudRate from './../assets/images/svg/menu/uart-baud-rate.svg';
import uartByteOrder from './../assets/images/svg/menu/uart-byte-order.svg';
import uartDataBit from './../assets/images/svg/menu/uart-data-bit.svg';
import uartDataType from './../assets/images/svg/menu/uart-data-type.svg';
import uartModbusCommandType from './../assets/images/svg/menu/uart-modbus-command-type.svg';
import uartModbusType from './../assets/images/svg/menu/uart-modbus-type.svg';


import notificationImg from './../assets/images/svg/menu/notification.svg';
// import notificationEngine from './../assets/images/svg/menu/notification-engine.svg';
// import notificationLog from './../assets/images/svg/menu/notification-log.svg';

// import creatorImg from './../assets/images/svg/menu/creator.svg';
// import kpi from './../assets/images/svg/menu/kpi.svg';
import hmi from './../assets/images/svg/menu/hmi.svg';

import DashboardIcon from '@mui/icons-material/Dashboard';

// import tankerImg from './../assets/images/svg/menu/tanker.svg';
export const DrawerComponent = (props) => {
    const drawerList = [
        {
            name: 'Dashboard',
            icon: <DashboardIcon />,
            path: '/dashboard'
        },
        {
            name: 'Creator - HMI',
            path: '/creator-hmi',
            src: hmi,
        },
        {
            name: 'EFM',
            src: systemConfig,
            screens: [
                { path: '/device-user-linking', name: 'Device User Linking', src: deviceConfig },
                { path: '/device-tag-linking', name: 'Device Tag Linking', src: deviceConfig },
                { path: '/efm-user', name: 'EFM User', src: deviceConfig },
            ]
        },
        {
            name: 'System Configuration',
            src: systemConfig,
            screens: [
                { path: '/device-config', name: 'Device Config', src: deviceConfig },
                { path: '/device-pending-request', name: 'Device Pending Request', src: devicePendingRequest },
                { path: '/device-history', name: 'Device History', src: deviceHistory },
                { path: '/device-logs', name: 'Device Logs', src: deviceLogs },
            ]
        },
        {
            name: 'Protocol',
            src: protocolImg,
            screens: [
                { path: '/color-palette', name: 'Color Palette', src: communicationChannel, },
                { path: '/communication-channel', name: 'Communication Channel', src: communicationChannel, },
                { path: '/device-image', name: 'Device Image', src: deviceImage },
                { path: '/device-graph', name: 'Device Graph', src: deviceGraph },
                { path: '/device-types', name: 'Device Types', src: deviceType },
                { path: '/frequency', name: 'Frequency', src: frequency },
                { path: '/hmi-device-card', name: 'HMI Device Card', src: hmiDeviceCard },
                { path: '/location', name: 'Locations', src: location },
                { path: '/status-code', name: 'Status Code', src: statusCode },
                { path: '/time-group', name: 'Time Group', src: timeGroup },

                {
                    name: 'UART Settings',
                    src: uart,
                    screens: [
                        { path: '/baud-rate', name: 'Baud Rate', src: uartBaudRate },
                        { path: '/byte-order', name: 'Byte Order', src: uartByteOrder },
                        { path: '/data-bit', name: 'Data Bit', src: uartDataBit },
                        { path: '/data-type', name: 'Data Type', src: uartDataType },
                        { path: '/modbus-command-type', name: 'Modbus Command Type', src: uartModbusCommandType },
                        { path: '/modbus-type', name: 'Modbus Type', src: uartModbusType },
                    ]
                },
            ]
        },
        {
            name: 'Notification',
            src: notificationImg,
            path: '/notification-engine',
            // screens: [
            //     { path: '/notification-engine', name: 'Notification Engine', src: notificationEngine },
            //     { path: '/notification-logs', name: 'Notification Logs', src: notificationLog },
            // ]
        },
    ];

    const [open, setOpen] = useState(-1);
    const [subOpen, setSubOpen] = useState(-1);

    useEffect(() => {
        drawerList.forEach((e, index) => {
            if (e?.screens !== undefined) {
                e?.screens.forEach((f, subIndex) => {
                    if (f.screens !== undefined) {
                        f.screens.forEach(g => {
                            if (g.path === props?.pathname) {
                                setOpen(index);
                                setSubOpen(subIndex);
                            }
                        });
                    } else if (f?.screens === undefined && f.path === props?.pathname)
                        setOpen(index);
                })
            } else if (e?.screens === undefined && e.path === props?.pathname)
                setOpen(index);
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.pathname])

    return <div>
        <Toolbar />
        <Divider />
        {drawerList.map((item, index) => (
            <List key={index} >
                {item.path === undefined && <>
                    <ListItemButton onClick={() => setOpen(open !== index ? index : -1)}>
                        <ListItemIcon className="justify-content-start">
                            {[undefined, null].includes(item.src) && item.icon}
                            {![undefined, null].includes(item.src) && <img alt="" src={item.src} className="img-fluid object-fit-contain" width={25} />}
                        </ListItemIcon>
                        <ListItemText primary={item.name} />
                        <ListItemIcon className="justify-content-end">{open === index ? <ExpandLess /> : <ExpandMore />}</ListItemIcon>
                    </ListItemButton>
                    <Collapse in={open === index} timeout="auto" unmountOnExit>
                        {item.screens.map((subItem, key) => <Fragment key={key}>

                            {subItem.screens === undefined ? <ListItem disablePadding className={`${props?.pathname === subItem.path && 'bg-color bg-green'}`}>
                                <ListItemButton sx={{ pl: 4 }} component={Link} to={subItem.path}>
                                    <ListItemIcon>
                                        {[undefined, null].includes(subItem.src) && subItem.icon}
                                        {![undefined, null].includes(subItem.src) && <img alt="" src={subItem.src} className="img-fluid object-fit-contain" width={25} />}
                                    </ListItemIcon>
                                    <ListItemText primary={subItem.name} />
                                </ListItemButton>
                            </ListItem> : <Fragment>
                                <ListItemButton sx={{ pl: 4 }} onClick={() => setSubOpen(subOpen !== key ? key : -1)}>
                                    <ListItemIcon className="justify-content-start">
                                        {[undefined, null].includes(subItem.src) && subItem.icon}
                                        {![undefined, null].includes(subItem.src) && <img alt="" src={subItem.src} className="img-fluid object-fit-contain" width={25} />}
                                    </ListItemIcon>
                                    <ListItemText primary={subItem.name} />
                                    <ListItemIcon className="justify-content-end">{open === index && subOpen === key ? <ExpandLess /> : <ExpandMore />}</ListItemIcon>
                                </ListItemButton>
                                <Collapse sx={{ pl: 4 }} in={open === index && subOpen === key} timeout="auto" unmountOnExit>
                                    {subItem.screens.map((subItemData, subKey) => <ListItem key={subKey} disablePadding className={`${props?.pathname === subItemData.path && 'bg-color bg-green'}`}>
                                        <ListItemButton sx={{ pl: 4 }} component={Link} to={subItemData.path}>
                                            <ListItemIcon>
                                                {[undefined, null].includes(subItemData.src) && subItemData.icon}
                                                {![undefined, null].includes(subItemData.src) && <img alt="" src={subItemData.src} className="img-fluid object-fit-contain" width={25} />}
                                            </ListItemIcon>
                                            <ListItemText primary={subItemData.name} />
                                        </ListItemButton>
                                    </ListItem>
                                    )}

                                </Collapse>
                            </Fragment>
                            }
                        </Fragment>
                        )}
                    </Collapse>
                </>}
                {item.path !== undefined && <ListItem disablePadding className={`${props?.pathname === item.path && 'bg-color bg-green'}`}>
                    <ListItemButton component={Link} to={item.path}>
                        <ListItemIcon>
                            {[undefined, null].includes(item.src) && item.icon}
                            {![undefined, null].includes(item.src) && <img alt="" src={item.src} className="img-fluid object-fit-contain" width={25} />}
                        </ListItemIcon>
                        <ListItemText primary={item.name} />
                    </ListItemButton>
                </ListItem>}
            </List>
        ))
        }
        <Divider />
    </div>
}